/* eslint-disable */
import axios from 'axios';
import EnvService from '@/plugins/EnvService';

export default class WebService {
  constructor(ctx) {
    console.log("WebService with ctx")
    this.ctx = ctx
    axios.defaults.validateStatus = () => {
      return true
    };
    axios.defaults.timeout = 1000 * 60 * 1 // 1min;
  }

  async getArtikel(restUrl) {
    return await axios.get(EnvService.serviceURLSdb+restUrl)
  }

  async getLanguageCountrys(restUrl) {
    return await axios.get(EnvService.serviceURLSdb+restUrl)
  }

  async getSdbItems(restUrl, cancelToken) {
    return await axios.get(EnvService.serviceURLSdb+restUrl, { cancelToken: cancelToken })
  }

  async getSdbPdf(restUrl, item) {
    return await axios.post(EnvService.serviceURLSdb+restUrl, item, {
      responseType: "blob",
      headers: {
        "Content-Type": "application/json"
      }
    })    
  }

  async getProductImage(restUrl) {
    return await axios.get(EnvService.serviceURLSdb+restUrl, {responseType: "blob"})
  }

  //Central Logging
  async createMessageLogEntry(restUrl, logEntry) {
    return await axios.post(EnvService.serviceURLSdb+restUrl, logEntry)
  }

  async getIp(restUrl) {
    //without EnvService.serviceURLPL is correct!
    return await axios.get(restUrl)
  }

  async getLoggingInfo(restUrl, appId, env) {
    return await axios.get(EnvService.serviceURLSdb+restUrl+"/"+appId+"/"+env)
  }

}
